module.exports = __webpack_public_path__ + "img/ogatev9-t.9c95f0a7.png";